import * as toastr from "toastr";
import LocalStorageAuthorizer from "source/app/infrastructure/Authorizer/LocalStorageAuthorizer";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import Login from "../Login";

export async function LoginAsLocalDevelopmentUser(login: Login) {
    try {
        const username = await ClientDataProvider.LoginAsLocalDevelopmentUser(
            login.state.username
        );
        LocalStorageAuthorizer.SignIn(username);
    } catch (error) {
        toastr.error(error.message, "Local development login error");
    }
}
